import angular from 'angular';
import SessionSyncService from './services/SessionSync.service';

const sessionSyncModule = angular
    .module('sessionSync', [])
    .service('SessionSync', SessionSyncService)
    .name;

export default sessionSyncModule; 